import { Box, Tab, Tabs } from '@mui/material'

const mainTabStyle = {
	'&.MuiTabs-root': {
		minHeight: 'unset',
	},
	'& .MuiButtonBase-root': {
		padding: '11px 16px',
		minHeight: 'unset',
		fontSize: '14px',
		fontFamily: 'Inter',
		fontWeight: '500',
		color: '#fff',
		textTransform: 'capitalize',
		'&.Mui-selected': {
			color: '#fff',
		},
	},
	'& .MuiTabs-indicator': {
		backgroundColor: '#fff',
	},
}

function CustomTabPanel({ children, value, index }) {
	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`admin-config-tabpanel-${index}`}
			aria-labelledby={`admin-config-tab-${index}`}
		>
			{value === index && <Box>{children}</Box>}
		</div>
	)
}

export function AdminConfigsTabs({
	value,
	onChange,
	weddingTasksPanel,
	pricingPanel,
}) {
	return (
		<Box sx={{ width: '100%' }}>
			<Box
				sx={{
					borderBottom: 1,
					borderColor: 'rgba(255, 255, 255, 0.28)',
				}}
			>
				<Tabs
					value={value}
					onChange={onChange}
					aria-label="Admin config sections"
					sx={mainTabStyle}
				>
					<Tab label="Wedding tasks & notifications" />
					<Tab label="Pricing" />
				</Tabs>
			</Box>
			<CustomTabPanel value={value} index={0}>
				{weddingTasksPanel}
			</CustomTabPanel>
			<CustomTabPanel value={value} index={1}>
				{pricingPanel}
			</CustomTabPanel>
		</Box>
	)
}
